import React from 'react';

import NotFound from 'components/NotFound';
import Forbidden from 'components/Forbidden';
import featureFlags from 'constants/featureFlags';
import ErrorPage from '../components/ErrorPage';
import NoAccessPage from '../components/NoAccessPage';
import Layout from '../components/Layout';
import authRouter from './AuthRouter';
import adminRouter from './AdminRouter';
import meteorologyRouter from './MeteorologyRouter';
import NewHome from '../views/NewHome';
import fluxRouter from './FluxRouter';
import fileViewerRouter from './FileViewerRouter';
import videosRouter from './VideosRouter';
import agroRouter from './AgroRouter';
import windxRouter from './WindxRouter';
import relatoriosRouter from './RelatoriosRouter';
import ColumnHeaderSelectSortDemo from '../components/DesignSystem/ColumnHeaderSelectSort/demo';
import CheckboxSelectorDemo from '../components/DesignSystem/Selector/CheckboxSelector/demo';
import AnomalyMapDemo from '../components/DesignSystem/AnomalyMap/demo';

const rootRouter = [
  {
    path: '/',
    element: <Layout />,
    errorElement: <ErrorPage />,
    children: [
      { path: '', element: <NewHome /> },
      { path: 'home', element: <NewHome /> },
      { path: 'demo/column-header-select-sort', element: <ColumnHeaderSelectSortDemo /> },
      { path: 'demo/checkbox-selector', element: <CheckboxSelectorDemo /> },
      { path: 'demo/anomaly-map', element: <AnomalyMapDemo /> },
      ...authRouter,
      { path: 'error', element: <ErrorPage /> },
      { path: 'no-access', element: <NoAccessPage /> },
      adminRouter,
      meteorologyRouter,
      agroRouter,
      fluxRouter,
      fileViewerRouter,
      videosRouter,
      // Windx ainda em desenvolvimento: a rota so e registrada quando a
      // feature flag esta ligada. Sem isso, /windx ficaria acessivel por
      // URL direta mesmo com a entrada da sidebar escondida.
      ...(featureFlags.windx ? [windxRouter] : []),
      ...(featureFlags.relatorios ? [relatoriosRouter] : []),
    ],
  },
  {
    path: '/forbidden',
    element: <Forbidden />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default rootRouter;
